
import Vue from 'vue'
import TextExcerpt from '@/components/common/TextExcerpt.vue'
import {Component} from 'vue-property-decorator'
import {Action, Getter, namespace} from 'vuex-class'
import BaseSubNavContainer from '@/containers/base/BaseSubNavContainer.vue'
import BaseListItemContainer from '@/containers/base/BaseListItemContainer.vue'
import {optionsVslim} from '@/config/v-slim-dialog'

const mailModule = namespace('mail')

@Component({
  components: {
    TextExcerpt,
    BaseSubNavContainer,
    BaseListItemContainer
  }
})
export default class ProspectBlocText extends Vue {
  @mailModule.Action('getMailBlocTextsAction') getMailBlocTexts: any
  @mailModule.Action('getMailBlocTextByIdAction') getMailBlocTextById: any
  @mailModule.Action('deleteMailBlocTextAction') deleteMailBlocText: any
  @mailModule.Action('syncMailBlocTextAction') syncMailBlocText: any
  @mailModule.Getter('mailBlocTextsGetter') mailBlocTexts: any

  panel = null

  mounted() {
    this.getMailBlocTexts()
  }

  beforeDestroy() {
    if (this.panel) this.panel.hide()
  }

  changeOrder(data) {
    this.syncMailBlocText(data)
  }

  async onPreview(item: any) {
    this.panel = this.$showPanel({
      component: 'previewConfigurationTextPanel',
      openOn: 'right',
      width: 700,
      keepAlive: false,
      props: {
        item
      }
    })
  }

  async onDelete(id: number) {
    const {ok} = await this.$dialogs.confirm('Confirmez vous la suppression du bloctext ?', optionsVslim)
    if (ok) {
      this.deleteMailBlocText(id).then(async () => {
        this.getMailBlocTexts()
      })
    }
  }
}
